import actionTypes from 'SRC/modules/redux/actionTypes'

export const setProfileUpdateError = error => ({
  type: actionTypes.SET_PROFILE_UPDATE_ERROR,
  payload: error
})
